var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-form-group',{attrs:{"state":_vm.state,"invalid-feedback":_vm.error}},[_c('b-form-file',{attrs:{"state":_vm.state,"placeholder":"Choose a CSV or ZIP...","drop-placeholder":"Drop CSV here...","accept":"application/zip,text/csv"},model:{value:(_vm.file),callback:function ($$v) {_vm.file=$$v},expression:"file"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }